import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import BrandMark from "@/components/BrandMark";
import NotificationBell from "@/components/NotificationBell";

export default function AppShell({ children, title, actions }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <header className="sticky top-0 z-40 border-b border-zinc-800 bg-black/90 backdrop-blur-md">
        <div className="px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to={user?.role === "trainer" ? "/app" : `/app/clients/${user?.id}`} className="block" data-testid="app-logo">
            <BrandMark size="sm" />
          </Link>
          <div className="flex items-center gap-4">
            <div className="hidden md:flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-zinc-500">
              <span className="text-zinc-300">{user?.name}</span>
              <span className="px-2 py-1 border border-zinc-800 text-[10px]" data-testid="user-role-badge">{user?.role}</span>
            </div>
            {user?.role === "trainer" && <NotificationBell />}
            <Button
              variant="outline"
              size="sm"
              className="rounded-none border-zinc-800 bg-transparent hover:bg-zinc-900 hover:text-white text-xs uppercase tracking-[0.2em]"
              onClick={async () => { await logout(); navigate("/"); }}
              data-testid="logout-button"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </header>
      <div className="px-6 md:px-10 py-8 max-w-7xl mx-auto">
        {(title || actions) && (
          <div className="flex flex-wrap items-end justify-between mb-8 gap-4">
            <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight" data-testid="page-title">{title}</h1>
            <div className="flex gap-2">{actions}</div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
